export const en = {
    admin: {
        user: 'Customer mode',
        userModeDescription:
            'When selected it shows the page the way the customer will see it',
    },
    app: {
        forvalter: 'Real estate dashboard',
        mittleieforhold: 'My lease',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        dynamics365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Authorizing...',
        loggingOut: 'Logging out...',
        login: 'Login',
        logout: 'Logout',
        // tslint:disable-next-line: max-line-length
        privacyDescription:
            'By using this site, you agree that we collect information used to improve the user experience for the users of this site. Read more about our privacy policy on ',
        privacyLinkTitle: 'privacy page.',
        sessionTimeout: 'Your session has expired',
        sessionTimeoutLoginAgain: 'Please login again.',
    },
    breadcrumbs: {
        availibleArea: 'Availible Area',
        building: 'Property',
        byggUtleie: 'Property rental',
        contractManagement: 'Contract Management',
        checkOff: 'Check-off',
        expiringArea: 'Expiring Contracts',
        dashboard: 'My Lease',
        invoice: 'Invoices',
        listUsers: 'Users',
        message: 'Message board',
        registerUser: 'Register user',
        reports: 'Reports',
        searchUsers: 'Search for users',
        selectClient: 'Select client',
        ticket: 'Tickets',
        forvaltningsplan: 'Management plan',
        environmentProfile: 'Environmental profile',
        keyFigures: {
            area: 'Area key figures',
            economy: 'Economy key figures',
        },
        project: {
            report: 'Project report',
            schema: 'Project forms',
        },
        leverandor: {
            schema: 'Supplier forms',
            documentation: 'Documentation',
            leverandorReport: 'Supplier Report',
        },
    },
    bygg: {
        favoritt: 'Add favorite',
        removeFavorite: 'Remove favorite',
        noBuildingsYet:
            'You do not have any buildings yet, but you can add buildings to the favorites list via the search field in the top menu.',
        myBuildings: 'My buildings',
        settings: {
            title: 'Settings',
            saveChanges: 'Save changes',
            showByggGrunn: 'Show plot in overview of buildings',
        },
    },
    chat: {
        tooltip: 'Chat with the real estate dashboard about contracts',
    },
    comments: {
        title: 'Comments: {{page}}',
        tooltip: 'Comments',
        datePickerLabel: 'Choose year',
        chooseYearDescription: 'Select which year the comment should apply to',
        newComment: 'New comment',
        editComment: 'Edit comment',
        edit: 'Edit',
        delete: 'Delete',
        highlight: 'Highlight',
        readMore: 'Read more',
        resetHighlightsFrontpage: 'Reset highlights on frontpage',
        close: 'Close',
        pin: 'Pin',
        titleLabel: 'Title',
        validation: {
            titleTooLong: 'Title can not be longer than 50 characters',
            titleOutOfRange:
                'Title cannot be shorter than 1 character or longer than 50 characters',
        },
        seeDetails: 'See details',
        updatedBy: 'Updated by:',
        edited: 'Last edited: ',
        published: 'Published: ',
    },
    editor: {
        paragraph: 'Paragraph',
        heading1: 'Heading 1',
        heading2: 'Heading 2',
        heading3: 'Heading 3',
        heading4: 'Heading 4',
        heading5: 'Heading 5',
        heading6: 'Heading 6',
        horizontalRule: 'Horizontal rule',
        insertTable: 'Insert table',
        loadingEditor: 'Loading editor...',
        addColumnBefore: 'New column before',
        addColumnAfter: 'New column after',
        deleteColumn: 'Delete column',
        addRowBefore: 'New row before',
        addRowAfter: 'New row after',
        deleteRow: 'Delete row',
        deleteTable: 'Delete table',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Open contract negotiation',
            contractNotFoundTitle: "Can't find your terms",
            contractNotFoundDescription:
                "You can find all your buildings' current rental conditions under the respective building",
            contractNotFoundLink: 'Go to my buildings',
            manualContractDescription:
                'You can get a copy of your contracts in PDF form by contacting your KLP property manager',
            manualContractTitle:
                'Are you looking for an existing PDF contract document?',
            title: 'Contract negotiations must be opened in a new tab',
            description: 'To open the contract negotiation, we need a new tab',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Open Projects',
            description: 'To open projects, we need a new tab',
            title: 'Projects will be opened in a new tab',
        },
    },
    environment: {
        // tslint:disable-next-line: max-line-length
        description:
            'This service may seem unstable for some periods. We are continuously developing and improving it and appreciate all your feedback and suggestions.',
        dev: 'DEV',
        environment: 'Environment: ',
        title: 'Environment',
        miljoprofil: 'Building environmental profile',
        powerBi: 'Environmental report',
        noContextSelected:
            'You need to look up a building department before you can see this',
        local: 'LOCAL',
        test: 'TEST',
    },
    faktura: {
        payments: 'Payments',
    },
    availableArea: {
        downloadSourceData: 'Download Available Areas as Excel',
        filedownloadname: 'Available_Areas{{lastname}}{{region}}.xlsx',
        potentialRevenue: 'Potential Market Value',
        totalArea: 'Total Area',
        table: {
            areaType: 'TYPE',
            buildingAddress: 'ADDRESS',
            buildingNo: 'NO.',
            floor: 'FLOOR',
            leaseObject: 'RENTAL OBJECT',
            leaseObjectId: 'RENTAL OBJECT ID',
            markedsprisLedigAreal: 'MARKET VALUE (NOK)',
            markedsprisPerM2: 'UNIT PRICE',
            physicalArea: 'AREA',
            property: 'PROPERTY',
            roomNo: 'ZONE NO',
            noMatch:
                'We found no available areas in the building department{{buildingName}} and / or portfolio you have selected.',
        },
    },
    file: {
        deleting_1: 'Deleting the file...',
        deleting: 'Deleting the files...',
        downloading: 'Downloading...',
        downloadingFinished: 'Download completed',
        fileNotFound: 'File not found',
        preview: 'Preview',
        previewDownload: 'PREVIEW / DOWNLOAD',
        downloadFailed: 'Download failed',
        saving_1: 'Saving the file...',
        saving: 'Saving the files...',
        selectFiles_0: 'Select file',
        selectFiles: 'Select files',
    },
    expiringContracts: {
        expirationProfile: {},
        keyFigures: {
            availableArea: 'Rentable area',
            availableAreaValue: 'Rentable M. Value ',
        },
        table: {
            amountYear: 'NOK/YEAR',
            area: 'AREA',
            areaType: 'TYPE',
            contractHeadExpiryDate: 'MAIN EXPIRY',
            contractLineExpiryDate: 'LINE EXPIRY',
            contractNumber: 'CONTRACT',
            customerName: 'CUSTOMER',
            customerNumber: 'CUSTOMER NO',
            description: 'DESCRIPTION',
            property: 'PROPERTY',
            sortingWeight: 'PRIORITY',
            noMatch:
                'We found no expiring contracts for the building department{{buildingName}} and / or portfolio you have selected.',
            filterReset: 'Remove filters',
            filterTitle: 'Filters:',
            pricePerAmount: 'NOK/PCS',
            pricePerUnit: 'UNIT PRICE',
            pricePerSquareMeter: 'NOK/m²',
        },
        downloadSourceData: 'Download Expiring Contracts as Excel',
        filedownloadname:
            'Expiring_Contracts{{lastname}}{{region}}{{from}}{{to}}.xlsx',
    },
    checkOffContract: {
        title: 'Contract {{kontraktnavn}}',
        signed: 'Signed: ',
        sender: 'Sender: ',
        noSender: 'No sender',
        subTitle: '{{kundeNavn}} ({{kundeNummer}})',
        tableDescription:
            'Registered contract lines for {{kundeNavn}} ({{kundeNummer}})',
        receivers: 'Receivers:',
        noReceivers: 'No signatories.',
        noDocuments: 'No documents have been uploaded for this contract.',
        saveButton: 'Save',
        saveButtonCompletedStep: 'Sharing My lease',
        cancelButton: 'Cancel',
        backButton: 'Back to the registration overview',
        document: 'Document: ',
        missingDocument:
            'Unfortunately, this document is not available for download and viewing',
        registerInD365: 'Register contract in D365:',
        registreringProsessLink: 'Go to registration for: {{type}}',
        processHeader: {
            Kontrakt: 'Register contract in D365:',
            Garanti: 'Register guarantee',
            Innflytningsprotokoll: 'Register tenant moving in',
            Utflytningsprotokoll: 'Register tenant moving out',
        },
        error: 'An error occurred while retrieving contract document. Please try again later.',
        tooltip:
            'The button is deactivated because the previous step is not completed, or because the current step has already been completed.',
        tooltipSendButton:
            'The button is deactivated because the contract document lacks contract lines.',
        shareButtonCompleted: 'Change sharing to My lease',
        shareButton: 'Share to My lease',
        startRegistrationButton: 'Start registration',
        successfulSending: 'The contract document has been shared.',
        shareDocumentHeading: 'Share contract document - {{kontraktnavn}}',
        secondaryTitle:
            'Link the contract document for {{kundeNavn}} ({{kundeNummer}}) to registered contract lines',
        shareDocumentWarning:
            'NB! Only share contract documents that are already registered in D365',
        dialog: {
            title: 'Are you sure that you want to assign to the selected consultant?',
            stepCompletion: 'Are you sure that you want to complete the step?',
        },
        notStartedActivity: 'The task has not been started.',
        insufficientUserRole:
            "The task requires the role(s) '{{role}}', you are not assigned this role.",
        completedActivity: 'The task was completed by: {{name}}, {{date}}',
        adminInformation:
            "The task requires the role '{{role}}' and is assigned to '{{assigned}}'. You have admin role and can change/perform the task.",

        roles: {
            Forvalter: 'Manager',
            Okonomi: 'Finance',
            QAOkonomi: 'Finance QA',
        },
        step: {
            // Vurder relevans
            Activity_1vr6y7a: {
                title: 'Assess relevance',
                secondaryTitle: 'Is the document relevant for registration?',
                description:
                    'Not all documents from Verified need to be registered. Select "Relevant" if the document is a contract, move-in protocol or move-out protocol, and then select the document type. Select "Not relevant" if the document is none of these, or is not relevant.',
                notRelevantButton: 'Not relevant',
                relevantButton: 'Relevant',
                cta: 'Complete step',
                completeButton: 'Complete',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            // Tildel økonomikonsulent
            Activity_1rdcqtp: {
                title: 'Assign financial consultant',
                secondaryTitle: 'Select a financial consultant',
                tertiaryTitle: 'Select a consultant',
                descriptionPartOne:
                    'We have chosen the building s financial consultant for you.',
                descriptionPartTwo:
                    'If you need to change this, you can do so here.',
                cta: 'Assign',
                chosenConsultant: 'Selected consultant:',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            sendToRegistration: {
                title: 'Send for registration',
                secondaryTitle: 'Registration in Dynamics 365',
                descriptionPartOne:
                    'We have sent a notice to {{navn}}, who will register the contract in D365.',
                descriptionPartTwo:
                    'You will receive a notification when the contract has been registered.',
                cta: 'Complete step',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            // Utfør registrering i D365
            Activity_0hw9rg3: {
                title: 'Register in D365',
                secondaryTitle: 'Registration in Dynamics 365',
                tertiaryTitle: 'Select a consultant',
                levendeKontrakterDescription:
                    'Based on information from Levende Kontrakter, we have created a draft for a new customer, {{kundeNavn}}, and a draft for registering this new contract ({{kundeNummer}}) to Onsite 365.',
                description:
                    ' Check the contents of the draft and complete the registration.',
                goToCustomer: 'Go to customer',
                goToContractDraft: 'Go to contract',
                goToLevendeKontrakter: 'Go to Levende Kontrakter',
                errorStatusNewCustomer: 'Could not create a new customer',
                errorStatusNewContractDraft: 'Could not create a new contract',
                D365Button: 'Open Onsite365',
                cta: 'Complete step',
                completeButton: 'Complete',
                selectController: 'Select the controller for registration',
                chosenConsultant: 'Selected consultant:',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            // Kontroll av registrering i D365
            Activity_1bk3epl: {
                title: 'Control of registration in D365',
                descriptionPartOne:
                    'If the contract is correctly registered in D365, it can be approved.',
                approveRegistrationButton: 'Approve registration',
                cta: 'Complete step',
                controlRegistration: 'Check registrered contract',
                goToCustomer: 'Go to customer',
                goToContractDraft: 'Go to contract',
                goToLevendeKontrakter: 'Go to Levende Kontrakter',
                D365Button: 'Open Onsite365',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            notifyManager: {
                title: 'Notify manager',
            },
            // Vurder gjennomgangsmøte
            Activity_1b84rij: {
                title: 'Consider review meeting',
                description:
                    'If it is a larger contract, it may be necessary to hold a review meeting with the manager.',
                reviewMeetingButton: 'Review meeting',
                continueButton: 'Continue',
                cta: 'Complete step',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },

            // Gjennomgangsmøte
            Activity_1m3ak5n: {
                title: 'Review meeting',
                descriptionPartOne:
                    'Finance has now completed the contract registration in D365 and wants to have a review meeting.',
                descriptionPartTwo:
                    'Prepare for the meeting by reviewing the draft invoice for the customer.',
                previewButton: 'Preview Invoice',
                approveRegistrationButton: 'Approve Registration',
                cta: 'Complete step',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            // Oppdater kundenummer i SuperOffice
            Activity_057tcgr: {
                title: 'Update customer number in SuperOffice',
                descriptionPartOne:
                    'Click on this link to update the customer number.',
                descriptionPartTwo:
                    'If the customer number is correctly registered, you can complete the current step and continue the registration.',

                descriptionPartThree:
                    'This is required to view an overview of contract lines for the contract document.',
                cta: 'Complete step',
                goToSuperoffice: 'Go to SuperOffice',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            // Knytt dokument og linje
            Activity_15vq4i6: {
                title: 'Link document and line',
                secondaryTitle:
                    'Registered contract lines for {{kundeNavn}} ({{kundeNummer}})',
                table: {
                    validToDate: 'TO',
                    validFromDate: 'FROM',
                    amount: 'AMOUNT',
                    areal: 'AREA',
                    yearlyPrice: 'NOK/YEAR',
                    kontraktId: 'CONTRACT NO',
                    id: 'ID',
                    name: 'NAME',
                    choose: 'CHOOSE',
                    noRelevantContractLines:
                        'We did not find any relevant contract lines for the customer within the signing period.',
                },
                cta: 'Complete step',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
            complete: {
                title: 'Complete',
                secondaryTitle: 'Registration Summary',
                table: {
                    tenant: 'Tenant',
                    area: 'Area',
                    leaseStart: 'Lease start',
                    invoiceAmount: 'Invoice amount',
                    property: 'Property',
                    parking: 'Parking',
                    endOfLease: 'End of lease',
                    invoiceDate: 'Invoice date',
                },
                completeRegistration: 'Complete registration',
                cancel: 'Cancel',
                completedBy: 'Completed by: {{name}}, {{date}}',
            },
        },
        table: {
            validToDate: 'TO',
            validFromDate: 'FROM',
            amount: 'AMOUNT',
            areal: 'AREA',
            yearlyPrice: 'NOK/YEAR',
            kontraktId: 'CONTRACT NO',
            kontraktLinjeIds: 'ID',
            name: 'NAME',
            choose: 'CHOOSE',
            noRelevantContractLines:
                'We did not find any relevant contract lines for the customer within the signing period.',
        },
    },
    contractRegistration: {
        oppslag: {
            sokLabel: 'Search (customer name or customer number)',
            sokUtenFiltre:
                'Searches all contracts. Other filters are turned off while searching.',
        },
        contractTypes: {
            Kontrakt: 'Contract',
            Garanti: 'Guarantee',
            Innflytningsprotokoll: 'Moving in',
            Utflytningsprotokoll: 'Moving out',
        },
        statuses: {
            checkedOff: 'Checked-Off',
            notCheckedOff: 'Not checked-off',
            new: 'New',
            shallNotBeRegistered: 'Shall not be registered',
            withForvalter: 'With Manager',
            assignedFinance: 'Assigned finance',
            registrationD365: 'Registration D365',
            forApporval: 'For approval',
            toQA: 'To QA',
            QACompleted: 'QA completed',
            approved: 'Approved',
            completed: 'Completed',
            RegistreringAvGaranti: 'Guarantee registration',
        },
        table: {
            actionMenuItems: {
                restartProcess: 'Restart process',
                showDetails: 'See details',
                assignFinancePerson: 'Assign eco. resp.',
                download: 'Download',
                notRelevant: 'Not relevant',
            },
            contracts: {
                statusCode: {
                    success:
                        'We have found a new registration for this customer.',
                    foundMultiple:
                        'We have found several new registrations. Double-check with the finance manager',
                    foundMultipleWithCount:
                        'We have found {{count}} new registrations within the 14 day registration period. Double-check this registration with the finance manager',
                    notFound: 'We can not find any information.',
                    error200:
                        'We can not find any recipients for the document in Verified or Superoffice.',
                    error302:
                        'We can not find customer number. Customer number may be incorrect in Superoffice or there exists no contacts matching the recipients.',
                    error300:
                        'We can not find a match with a contract. Either the contract has not been signed yet or it has just been signed. It may take up to 14 days from signing before it is visible.',
                    error303:
                        'We do not find a match for contract. If more than 14 days have passed between signing and registration, it will not appear here. You can contact the finance manager for more information.',
                    error301: 'We can not find building number.',
                    error100:
                        'We can not find a reference to the document. The document is not registered via Verified or Superoffice, but has been uploaded to Superoffice.',
                },
            },
            checkOff: 'CHECK-OFF',
            contractDocument: 'DOCUMENT',
            signDate: 'SIGNED',
            propertyManager: 'PROPERTY MANAGER',
            economyPerson: 'ECONOMY',
            property: 'PROPERTY',
            tenant: 'TENANT',
            kundeNummer: 'CUSTOMER NO',
            action: 'ACTION',
            type: 'TYPE',
            registeredDate: 'Registered',
            statusCode: {
                title: 'STATUS',
                titleHelpText:
                    'Indicates if there are registered a new contact for this customer within 14 days of signing.',
                error: 'There is an error with the registration of the Document in SuperOffice',
                noPropertyWarning:
                    'We cannot find any information about the property on this contract. A common reason is that the document in SuperOffice is not linked to a project or a sale. ',
                noEconomyWarning:
                    'We cannot find any information about the responsible economy person for this property. A common reason is that the document in Superoffice is not linked to a project or a sale.',
                noTenantWarning:
                    'We cannot find any information about the property manager for this property. A common reason is that the document in Superoffice is not linked to a project or a sale or that the contact is not created.',
            },
            email: {
                subjectText: 'Registration of a contract in ',
                helpTextOkonomi:
                    'Send an email to the responsible economy person',
                helpTextForvalter:
                    'Send an email to the responsible property manager',
            },
            emptyTableMessage:
                'We cannot find any contracts for the building department and / or portfolio you have selected.',
        },
        title: 'D365 registration follow-up',
        notification: 'Processing the request. Please wait..',
        error: 'An error has occurred. Please try again.',
        errorSaveForm: 'An error occurred while saving form content.',
        successfulRegistration: 'The contract document has been recorded.',
        successfulOperation: 'The operation was successful.',
        newProcess: 'New documents',
        ongoingProcessForvalter: "At Property Manager's",
        ongoingProcessFinance: "At Economy's",
    },
    contractManagement: {
        leko: 'Contract Negotiation',
        negotiation: 'Negotiation',
        overview: 'Contracts',
        registrer: 'Registration',
        sign: 'Signing',
        title: 'Contract Management',
        ongoingProcesses: 'Ongoing processes',
        forSigning: 'For signing',
        forRegistration: 'For registration',
    },
    contract: {
        amountYear: 'Amount per year',
        area: 'Gross',
        availableArea: 'Available area',
        availableAreaValue: 'Available M. Value',
        chartTitle: 'Expiry profile:',
        contractExpiry: 'Contract expiry',
        customerName: 'Customer',
        expiringArea: 'Expiring area',
        expiringContracts: 'Expiring contracts',
        ExpiringContracts: 'Expiring Contracts',
        expiringContractValue: 'Expiring income',
        expiringLines:
            '{{contractCount}} contract lines expires between {{from}} and {{to}}',
        expiry: {
            expired: 'Has expired',
            expires_within_1y: 'Expires within 1 year',
            expires_within_2y: 'Expires within 2 year',
            expires_within_3y: 'Expires within 3 years',
            expires_within_4y: 'Expires within 4 years',
            expires_within_6m: 'Expires within 6 months',
            eternal: 'No expiration date',
        },
        expiryProfileTime: {
            expired: 'Expiry Profile (Expired):',
            expires_within_6m: 'Expiry profile (6 mths):',
            expires_within_1y: 'Expiry profile (1 yr):',
            expires_within_2y: 'Expiry profile (2 yrs):',
            expires_within_3y: 'Expiry profile (3 yrs):',
            expires_within_4y: 'Expiry profile (4 yrs):',
            eternal: 'Expiry profile (No expiration date):',
        },
        keyFiguresTime: {
            expired: 'Key Figures: (Expired)',
            expires_within_6m: 'Key Figures (6 mths):',
            expires_within_1y: 'Key Figures (1 yr):',
            expires_within_2y: 'Key Figures (2 yrs):',
            expires_within_3y: 'Key Figures (3 yrs):',
            expires_within_4y: 'Key Figures (4 yrs):',
            eternal: 'Key Figures (No expiration date)',
        },
        expiryRateNOK: 'Expiration rate (NOK)',
        income: 'Rental income',
        keyFigures: 'Key figures ({{date}}):',
        leasedArea: 'Leased area',
        lineExpiry: 'Contractline expiry',
        lineName: 'Description',
        number: 'Contract',
        pcs: 'pcs',
        property: 'Property',
        rentalStatusPerDate: 'Rental Status ({{date}}):',
        selectExpiry: 'Select expiry',
        sortingWeight: 'Weight',
        title: 'contract',
        totalArea: 'Total area',
        totalPotentialIncome: 'Total P. income',
    },
    ledigAreal: {
        keyFigures: {
            areaAvailable: 'Available area',
            areaLeased: 'Leased Area',
            availableAreaValue: 'Available M. Value',
            rentalIncome: 'Rental Income',
            totalArea: 'Total Area',
            totalPotentialIncome: 'Total P. Income',
        },
        areaAvailable: 'Available area',
        areaLeased: 'Leased area',
        areaRatio: 'Area-wise Rental Ratio',
        areaToExpire: 'Expiring areal',
        areaType: 'type',
        buildingAddress: 'Address',
        buildingNo: 'No.',
        floor: 'Floor',
        leaseObject: 'Lease Object',
        leaseObjectId: 'Lease Object Id',
        markedsprisLedigAreal: 'Market Value (NOK)',
        markedsprisPerM2: 'M. Value m²',
        physicalArea: 'Area',
        plotId: 'PlotID',
        property: 'Property',
        section: 'Section',
        title: '{{count}} areas are available',
    },
    portfolio: {
        all: 'All portfolios',
        select: 'Select portfolio',
    },
    region: {
        all: 'All regions',
        select: 'Select region',
    },
    filterPanel: {
        nullstill: 'Reset',
        alle: 'All',
        portefolje: 'Portfolio',
        region: 'Region',
        status: 'Status',
        endretEtter: 'Changed after',
        signertEtter: 'Signed after',
        antall: 'Max number',
        tomFelt: 'Clear the field',
        laster: 'Loading',
        tildeltMeg: 'Assigned to me',
        visTildelt:
            'Shows forms assigned to you. Search and other filters are turned off.',
        sokUtenFiltre:
            'Searches all forms. Other filters are turned off while searching.',
        velgFilter: 'Search, or choose at least one filter to show forms.',
    },
    status: {
        all: 'All statuses',
        select: 'Select status',
        filter: 'Filter',
        selectedCount: '{{antall}} selected',
    },
    keyfigures: {
        title: 'Key figures',
        areaTitle: 'Area',
        economyTitle: 'Economical',
        noContextSelected:
            'You need to look up a building department before you can see this',
    },
    forvaltningsplan: {
        title: 'Management plan',
        noContextSelected:
            'You need to look up a building department before you can see this',
        edit: 'Edit',
        read: 'Read',
    },
    users: {
        title: 'User Overview',
        searchField: 'Search for user',
        fullname: 'Name',
        name: 'First Name',
        surname: 'Last Name',
        email: 'Email',
        roles: 'Roles',
        region: 'Region',
        noUsers: 'No users found.',
        editUser: {
            title: 'Manage user',
            titleWithName: 'Manage user: {{name}}',
            backButton: 'Back to user overview',
            assignRoles: 'Assign Roles',
            rolesDescription: 'Enter which roles the user has',
            assignRegion: 'Assign region',
            regionDescription: 'Enter which region the user belongs to',
            regionRequired: 'Region is required',
        },
        showUserInfo: {
            title: 'Show user info',
            secondaryTitle: 'User info for {{name}}',
            backButton: 'Back to user overview',
            labelRoles: 'Roles',
            rolesDescription: 'The user has the following roles',
            labelRegion: 'Region',
            regionDescription: 'The user belongs to the following region',
            prosjektkontrollerDescription:
                'The user is responsible for the following building sections and companies as project controller',
            labelBygg: 'Building sections',
            labelFirma: 'Companies',
        },
        action: {
            label: 'Action',
            byggProsjektkontroller: 'Edit project controller responsibilities',
        },
        bpkModal: {
            title: 'Edit building sections and companies for project controller',
            description:
                'Add building sections and companies where the user is responsible for as a project controller',
            assigned: 'assigned',
            labelBygg: 'Select building sections',
            labelFirma: 'Select companies',
            save: 'Save',
            assignedByggWarning:
                'The following buildings will be transferred to {{name}}',
            assignedFirmaWarning:
                'The following companies will be transferred to {{name}}',
            saveCompletion:
                'Are you sure you want to transfer {{values}} to {{name}}?',
        },
        save: 'Save',
        regionSelector: {
            Danmark: 'Denmark',
            Trondheim: 'Trondheim',
            Oslo: 'Oslo',
            Sverige: 'Sweden',
            Alle: 'All',
            Europa: 'Europe',
        },
        rolesSelector: {
            Teamleder: 'Team Leader',
            Drift: 'Operations',
            Forvalter: 'Manager',
            Okonomi: 'Finance',
            OkonomiQA: 'Finance QA',
            Prosjekteier: 'Project Owner',
            Prosjektleder: 'Project Leader',
            Prosjektkontroller: 'Project Controller',
            Prosjektdirektor: 'Project Director',
            Forvaltningsdirektor: 'Management Director',
            Utviklingsdirektor: 'Development Director',
            Administrerendedirektor: 'CEO',
            Okonomisjef: 'Finance Manager',
            Teknisksjef: 'Technical Manager',
            'user-admin': 'User Administrator',

            Avdelingsleder: 'Department Manager',
            Ledergruppedirektor: 'Management Group Director',
            Risikovurderer: 'Risk Assessor',
            Leverandoroppretter: 'Supplier Creator',
            FagansvarligAapenhetsloven: 'Subject manager for Åpenhetsloven',
            Eiendomssjef: 'Property Manager',
            Regiondirektor: 'Regional Director',
        },
    },
    formGenerator: {
        approve: 'Approve',
        disapprove: 'Reject',
        submit: 'Complete task',
        fieldRequired: 'This field is required',
        maxLengthExceeded: 'The text cannot be longer than {{max}} characters',
        characterCount: '{{length}} / {{max}} characters',
        assign: {
            title: 'Need help filling out the form?',
            description:
                'Assign the task "{{oppgave}}" to a colleague with the right role ({{rolle}}) to get help filling out the form.',
            assignTo: 'Assign to',
        },
        confirmDialog: {
            confirmDisapproval: 'Are you sure you want to reject the form?',
            confirm: 'Yes, reject',
        },
        roles: {
            Teamleder: 'Team Leader',
            Drift: 'Operations',
            Forvalter: 'Manager',

            Bestiller: 'Orderer',
            Avdelingsleder: 'Department Manager',
            Ledergruppedirektor: 'Management Group Director',
            Risikovurderer: 'Risk Assessor',
            Leverandoroppretter: 'Supplier Creator',

            Prosjekteier: 'Project owner',
            Prosjektleder: 'Project manager',
            Teknisksjef: 'Technical manager',
            Eiendomssjef: 'Property manager',
            Prosjektdirektor: 'Project director',
            Forvaltningsdirektor: 'Director of administration',
            Utviklingsdirektor: 'Director of development',
            Regiondirektor: 'Regional director',
            Administrerendedirektor: 'Managing director',

            Prosjektkontroller: 'Project controller',
            Okonomi: 'Accounting manager',
            OkonomiQA: 'Finance QA',
            Okonomisjef: 'Chief financial officer',

            'user-admin': 'User Administrator',
        },
        unsupportedFieldType: {
            title: 'Unsupported Field Type',
            message:
                'The field you are trying to render is not supported in this form. Please check the field type or contact support.',
            reloadButton: 'Reload form',
        },
    },
    leverandor: {
        oppslag: {
            sokLabel: 'Search (supplier number, org. number or org. name)',
        },
        title: 'Supplier Management',
        heading: 'Supplier Form',
        placeholder: 'Supplier list comes here',
        abort: 'Abort',
        review: 'Review',
        opprettetAv: 'Created by',
        completedBy: 'Completed by: {{name}}\n{{date}}',
        completedDate: 'Completed: {{date}}',
        ansvarlig: 'Responsible: {{name}}',
        menuItems: {
            leverandor: 'Supplier List',
            root: 'Supplier',
            skjema: 'Forms',
            leverandorReport: 'Supplier Report',
        },
        noContextSelected:
            'You need to look up a supplier before you can see this',
        notFound:
            'The supplier you are trying to open does not exist. Please return to the overview and select a supplier from the list.',
        backButton: 'Back to supplier overview',
        header: {
            documentation: 'Documentation',
        },
        cantFindProjectSchema:
            'An error occurred. Could not find supplier form',
        activityAssignedToOtherUser:
            "The task is assigned to '{{assigned}}', you cannot therefore change/complete the task.",
        assignActivityToMe: 'Assign task to me',
        insufficientUserRole:
            "The task requires the role '{{role}}', you are not assigned this role.",
        adminInformation:
            "The task requires the role '{{role}}' and is assigned to '{{assigned}}'. You have admin role and can change/complete the task.",
        completedActivity: 'The task has already been completed.',
        rejectedActivity: 'The schema has been rejected.',
        skipActivity:
            'This task is not relevant for the flow and will be skipped',
        deviationSystemLink: 'Link to deviation system',
        processDefinition: {
            breadcrumb: 'Flow diagram',
            back: 'Back to documentation',
            title: 'Visual representation of process definition flow diagram: {{processDefinitionId}}',
            iconTitle:
                'See more detailed representation of process definition flow diagrams',
            documentationTitle:
                'Documentation of process definition flow diagrams',
            selector: 'Select process definition',
            helperText: 'Select process definition to filter suppliers',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            resetZoom: 'Reset zoom',
            read: 'Open external link to Confluence page for process definition(s)',
        },
        table: {
            emptyTableMessage: 'No suppliers found',
            orgnummer: 'ORG NUMBER',
            superOfficeContactId: 'Supplier SO ID',
            d365Leverandornummer: 'Supplier Number',
            superOfficeDocumentId: 'SuperOffice Document ID',
            navn: 'Name',
            type: 'Type',
            bestiller: 'Orderer',
            okonomi: 'Economics',
            avdelingsleder: 'Department Manager',
            ledegruppeDirektor: 'Management Group Director',
            ansvarlig: 'Assigned to',
            opprettetAv: 'Created by',
            startDato: 'Start Date',
            fullfortDato: 'Completed Date',
            action: 'Actions',
            status: 'Status',
            aktivitet: 'Task',
            klassifisering: 'Classification',
            feltOppdateringFeilet: 'Could not update the field {{fieldName}}',
            ugyldigJSONBransje:
                'The industry field contains invalid data and cannot be read.',
            ugyldigJSONKlassifisering:
                'The classification field contains invalid data and cannot be read.',
            actionMenuItems: {
                currentHeader: 'Actions for form',
                visLeverandorSkjema: 'Show form',
                dokumentasjon: 'Show documentation',
                lastNedDokument: 'Download document',
                forhaandsvisDokument: 'Preview document',
                tildel: 'Assign new responsible',
                sendReminder: 'Send reminder to responsible',
                sendKommentar: 'Send comment to role holder',
            },
            tildelAnsvarlig: {
                title: 'Assign new responsible',
                ansvarlig: 'Responsible',
                tildel: 'Assign',
                avbryt: 'Cancel',
            },
            roller: {
                Bestiller: 'Orderer',
                Avdelingsleder: 'Department Manager',
                Ledergruppedirektor: 'Management Group Director',
                Risikovurderer: 'Risk Assessor',
                Leverandoroppretter: 'Supplier Creator',
                FagansvarligAapenhetsloven: 'Subject manager for Åpenhetsloven',
                Okonomi: 'Accounting',

                Prosjekteier: 'Project owner',
                Prosjektleder: 'Project manager',
                Forvaltningsdirektor: 'Director of administration',
                Utviklingsdirektor: 'Director of development',
                Administrerendedirektor: 'Managing director',
                Prosjektdirektor: 'Project director',
                Okonomisjef: 'Chief financial officer',
                Prosjektkontroller: 'Project controller',
                Teknisksjef: 'Technical manager',
                Eiendomssjef: 'Property manager',
                Regiondirektor: 'Regional director',

                Ukjent: 'No roles',
            },
            registreringStatus: {
                UnderVurdering: 'Under Review',
                Avvist: 'Rejected',
                Fullfort: 'Completed',
            },
        },
        statuses: {
            UnderVurdering: 'Under Review',
            Fullfort: 'Completed',
            Avvist: 'Rejected',
        },
        displayStatuses: {
            underGodkjenning: 'Under Approval',
            godkjent: 'Approved',
            ikkeGodkjent: 'Not Approved',
        },
        successfulRegistration: 'The supplier has been registered.',
        successfulOperation: 'The action was completed successfully.',
        notAssignedToUser:
            'You are not assigned this task and therefore cannot complete it.',
        notAllowedToPerformAction:
            'You do not have access to perform this action.',
        deleteLeverandor: {
            title: 'Delete form',
            confirmationText: 'Are you sure you want to delete the form?',
        },
        sendKommentar: {
            title: 'Send comment to role holder',
            selectRole: 'Select role',
            commentLabel: 'Comment',
            send: 'Send',
        },
        opprettLeverandor: {
            title: 'Create supplier form',
        },
        createLeverandor: {
            title: 'Create supplier form',
            button: 'Create supplier form',
            navigateToSchema: 'Navigate to Schema',
            successfulOperation: 'Supplier created successfully.',
            existingProcessFound: 'A process for this supplier already exists.',
            validation: {
                regionRequired: 'Region is required',
                orgnummerRequired: 'Organization number is required',
                orgnummerDigits: 'Organization number must be only digits',
                typeRequired: 'Type is required',
                countryRequired: 'Country is required',
            },
            region: {
                label: 'Select region for the supplier',
                oslo: 'Oslo',
                trondheim: 'Trondheim',
                sverige: 'Sweden',
                danmark: 'Denmark',
                europa: 'Europe',
            },
            country: {
                Norway: 'Norway',
                Sweden: 'Sweden',
                Denmark: 'Denmark',
                UnitedKingdom: 'United Kingdom',
                Other: 'Other',
            },
            orgnummer: {
                label: 'Select organization',
                placeholder: 'Search for name or org.number',
                placeholderSweden: 'Search for org.number',
            },
            manualEntry: {
                nameLabel: 'Company name',
                namePlaceholder: 'Enter company name',
                orgNumberLabel: 'Organization number',
                orgNumberPlaceholder: 'Enter org.number',
                countryLabel: 'Country',
                countryPlaceholder: 'Enter country name',
            },
            superOffice: {
                label: 'SuperOffice Contact',
                loading: 'Searching SuperOffice...',
                notFoundAlert: 'No existing company found',
                notFoundAlertDescription:
                    'A new company will be created in SuperOffice',
                foundAlert: 'Existing company found',
                foundAlertDescription:
                    'Existing company will be used: {{navn}}',
                error: 'Error searching SuperOffice',
                selectOption: 'Select company',
                companyId: 'SuperOffice Company ID',
                klassifisering: 'Classification',
            },
            duplicateSuperofficeContactsFound:
                '{{count}} existing SuperOffice companies found for this organization. Please select which one to use:',
            type: {
                label: 'Type',
                fastleverandor: 'Regular Supplier',
                engangsleverandor: 'One-Time Supplier',
                engangsleverandorInfo:
                    'A one-time supplier can only be used once for amounts less than 15,000 NOK/15,000 SEK/10,000 DKK (excl. VAT)',
            },
        },
        TildelKommentarer: {
            field: {
                label: 'Comment when assigning',
                placeholder:
                    'Enter a comment for the person you are assigning to',
                error: {
                    commentTooLong:
                        'Could not save the comment in the form. The comment is too long and exceeds the permitted length.',
                },
            },
            list: {
                title: 'Comments when assigning',
                empty: 'No comments',
            },
        },
        rolleKommentarer: {
            list: {
                title: 'Comments',
                empty: 'No comments',
                reply: 'Reply',
                replyTo: 'Reply to {{role}}',
                cannotDelete: 'Cannot delete comments with replies',
                fra: 'From',
                til: 'To',
                svarTil: 'Reply to',
            },
            field: {
                error: {
                    commentTooLong:
                        'The comment is too long and exceeds the permitted length.',
                },
            },
        },
        risikovurdering: {
            openButton: 'Open Risk assessment',
            updateButton: 'Fill fields with values from Risk Assessment',
            button: 'Risk Assessment',
            notFoundInDNB: 'Cannot find supplier in DNB for risk assessment',
            fieldsUpdated: 'Fields have been updated',
            updateError: 'Error updating fields',
            fetchError: 'Error fetching risk assessment data',
        },
        inherentRisk: {
            breadcrumb: 'Inherent Risk',
            title: 'Industries - Inherent Risk',
            subtitle: 'Assessment of inherent risk for different industries',
            selectRiskLabel: 'Select risk level',
            low: 'Low risk',
            medium: 'Medium risk',
            high: 'High risk',
            notSet: 'Not set',
            searchPlaceholder: 'Search for industry',
            success: 'Risk assessment updated',
            error: 'Error updating risk assessment',
            table: {
                bransje: 'Industry',
                beskrivelse: 'Description',
                risk: 'Risk level',
            },
        },
        schemaRisk: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            schemaWarning:
                'The assessment of the supplier shows high risk in relation to the Norwegian Åpenhetsloven. Lucas van Laack (Sustainability Manager) will be included in the process for a due diligence assessment and further follow-up. Remember that the orderer is always the risk owner.',
            schemaSafe:
                'The assessment shows low or medium risk in relation to the Norwegian Åpenhetsloven. No action required.',
        },
        processId: 'Process ID',
        startDate: 'Start Date',
        startedBy: 'Started By',
        region: 'Region',
    },

    project: {
        title: 'Project- and initiative forms',
        header: {
            documentation: 'Documentation',
            fullmakt: 'Authorization limits',
        },
        noContextSelected:
            'You need to look up a building department before you can see this',
        notFound:
            'The project you are trying to open does not exist. Please return to the overview and select a project from the list.',
        backButton: 'Back to the project overview',
        backButtonHistorikk: 'Back to project summary',
        menuItems: {
            root: 'Project / initiative',
            schema: 'Forms',
            report: 'Report',
        },
        abort: 'Abort',
        review: 'Review',
        opprettetAv: 'Created by',
        completedBy: 'Completed by: {{name}}\n{{date}}',
        completedDate: 'Completed: {{date}}',
        tildelt: 'Assigned:',
        ansvarlig: 'Responsible: {{name}}',
        formFields: {
            aarsbudsjett: 'Annual Budget',
            mainTitle: 'Project- and initiative form',
            generelleOpplysningerTitle: 'General Information',
            eiendomsnavn: 'Property Name',
            delAvEiendom: 'Part of Property',
            utleieareal: 'Rental Area',
            prosjektareal: 'Project Area',
            informationOmProsjekt: 'Project Information',
            oppstartsdato: 'Start Date',
            mvapliktig: 'Is the tenant VAT liable (0-100%)?',
            opprettetSuperOffice: 'Is the project created in SuperOffice?',
            lonnsomhetsberegning:
                'Profitability calculation approved by the department head and saved in SuperOffice?',
            lonnsomhetsberegningLink:
                'Link to profitability calculation in SuperOffice',
            signertLeietaker: 'Received lease agreement signed by the tenant?',
            signertLeietakerLink: 'Link to signed lease agreement',
            signertKLP: 'Lease agreement signed by KLP?',
            prosjektBudsjett: 'Project Budget',
            prosjektokonomiTitle: 'Project Economy',
            budsjettert: 'Budgeted?',
            pbv1: 'PB V1',
            andelKostnadsforing: 'Cost Allocation',
            leietakerTitle: 'Tenant',
            firmanavn: 'Company Name',
            firmanavnSøkeresultat: 'Company Name (Search Result)',
            organisasjonsnummer: 'Organization Number',
            sendVidereTilTitle: 'Forward To',
            prosjektleder: 'Project Manager',
            utviklingsdirektor: 'Development Director',
            kommentarerTitle: 'Comments',
            kommentarForvaltningsdirektor: 'Comment - Management Director',
            kommentarForvaltningsdirektorGodkjent:
                'The project is approved by the Management Director with the following comment',
            kommentarUtviklingsdirektor: 'Comment - Development Director',
            kommentarUtviklingsdirektorGodkjent:
                'The project is approved by the Development Director with the following comment',
            kommentarAdministrerendedirektor: 'Comment - CEO',
            kommentarAdministrerendedirektorGodkjent:
                'The project is approved by the CEO with the following comment',
            kommentarProsjektdirektor: 'Comment - Project Director',
            kommentarProsjektdirektorGodkjent:
                'The project is approved by the Project Director with the following comment',
            prosjektcontroller: 'Project Controller',
            andreSystemerTtle: 'Other Systems',
            prosjektNummerAxapta:
                'Created in Axapta and the following is the correct project number',
            firmaDetaljer: {
                registrertIMvaregisteret: 'Registered in the VAT registry',
                registrertIForetaksregisteret:
                    'Registered in the Business Registry',
                registreringsdatoEnhetsregisteret:
                    'Registered in the Entity Registry',
                registreringsdatoAntallAnsatteNAVAaregisteret:
                    'Registered in NAV Aa-registry',
                konkurs: 'Bankruptcy',
                underAvvikling: 'Under liquidation',
                underTvangsavviklingEllerTvangsopplosning:
                    'Under forced liquidation or dissolution',
            },
            manuellRegistrering: 'Manual registration',
            firmanavnManuell: 'Company name',
            manueltRegistrertInfo:
                'Manually registered — no data from Brønnøysund registry',
            radioGroup: {
                yes: 'Yes',
                no: 'No',
            },
            calculatedSelectorEditable: {
                editedLabel:
                    'The automatically calculated value of {{value}} has been overwritten. You can reset it by clicking the cross icon in the field above.',
            },
        },
        steps: {
            step1: {
                title: 'Define project',
                description:
                    'The project is defined and the project manager is appointed',
            },
            step2: {
                title: 'Check and correct',
                description:
                    'The project is checked and corrected by the Management Director',
            },
            step3: {
                title: 'Management Director approval',
                description:
                    'The project is approved by the Management Director',
            },
            step4: {
                title: 'Development Director approval',
                description:
                    'The project is approved by the Development Director',
            },
            step5: {
                title: 'CEO approval',
                description: 'The project is approved by the CEO',
            },
            step6: {
                title: 'Project Controller',
                description:
                    'The project is approved by the Project Controller',
            },
        },
        opprettProsjekt: {
            title: 'Create project / initiative form',
            type: 'Type',
            step: 'Step',
            selectStep: 'Select step',
            noStepSelected: '--- No value ---',
            superOfficeProsjekt: 'SuperOffice project',
            superOfficeProsjektPlaceholder: 'Search for SuperOffice project',
            opprettProsjektKnapp: 'Create project / initiative form',
            goToSuperOffice: 'Go to SuperOffice',
            prosjektskjematype: {
                label: 'Choose project form type',
                hovedprosjekt: 'Main project',
                underprosjekt: 'Subproject',
            },
            // If an analysis of costs and profitability is to be carried out for the project, select "Profitability assessment". \n\n
            LTT: 'If a preliminary project is needed, either to prepare an offer for the tenant, or a request for quotation for contractors, select "Preliminary project". \n\nIf the lease has been signed and the project manager have chosen a contractor, you can go straight to "Implementation".',
            KOM: 'If you need to prepare some simple sketches or do other minor research in advance of a preliminary project, and which has a total cost of less than 50,000, -, select "Sketch". \n\nIf you need a project manager, or the total cost for sketches and research exceeds 50,000, -, select "Preliminary project".',
            TEK: 'With preliminary project?',
            prosjekterNotFound:
                'No projects found, go to SuperOffice to create project',
            radioGroup: {
                Lonnsomhetsberegning: {
                    title: 'Profitability assessment',
                },
                Skisse: {
                    title: 'Sketch',
                    KOM: 'Need to prepare some simple sketches or do other minor research in advance of a preliminary project, with a total cost of less than 50,000,-',
                },
                Forprosjekt: {
                    title: 'Preliminary project',
                    LTT: 'Need for preliminary project, either to prepare an offer for the tenant, or request for quotation to contractors',
                    KOM: 'Need for a project manager, or the total cost for sketches and research exceeds 50,000,-',
                    TEK: 'Need for preliminary project, either to prepare an offer for the tenant, or request for quotation to contractors',
                },
                Gjennomforing: {
                    title: 'Implementation',
                    LTT: 'The lease has been signed and the project manager has chosen a contractor',
                    TEK: 'The lease has been signed and the project manager has chosen a contractor',
                },
                Tilbud: {
                    title: 'Offer',
                },
            },
            disabledButton:
                'To create a project form, you must select type and subcategory',
            occupiedProject: ' --- The PROJECT IS USED ---',
            types: {
                LTT: 'Tenant adaptation (LTT)',
                KOM: 'Commercial (KOM)',
                TEK: 'Technical (TEK)',
                TILTAK: 'Initiatives',
            },
        },
        types: {
            LTT: 'Tenant adaptation',
            LTT_Abbreviation: 'LTT',
            KOM: 'Commercial',
            KOM_Abbreviation: 'KOM',
            TEK: 'Technical',
            TEK_Abbreviation: 'TEK',
            TILTAK: 'Initiatives',
            Unknown: 'Unknown type',
        },
        subTypes: {
            Opprettelse: 'Creation',
            Skisse: 'Sketching',
            Igangsettelse: 'Commisioning',
            Bestilling: 'Order',
            Endring: 'Change',
            Avslutning: 'Completion',
        },
        stepTypes: {
            Ny: 'New',
            Avvist: 'Rejected',
            Fullfort: 'Completed',
        },
        errors: {
            invalidLink: 'Link is not valid',
            invalidProjectNumber:
                'Project number must be in the form "<Company number>.<D365 serial number (4 digits)>" e.g. "N202.0435"',
            savePrompt: 'An error occurred while saving form content.',
            companyNotSelected:
                'Please search for the business name or number and select one from the list.',
            invalidOrgnumber: 'Invalid organization number',
            invalidTotalVurderingsskjema:
                'Invalid sum - value must be greater than 0',
        },
    },
    prosjekt: {
        cantFindProjectSchema:
            'An error has occured. Could not find project/initiative schema',
        oppslag: {
            sokLabel: 'Search (project number, project name or property)',
        },
        activityAssignedToOtherUser:
            "The task is assigned to '{{assigned}}', therefore you cannot change/perform the task.",
        assignActivityToMe: 'Assign task to me',
        insufficientUserRole:
            "The task requires the role '{{role}}', you are not assigned this role.",
        notCandidateGroupOwner:
            "To complete this task you must be assigned the role '{{owner}}'. Your roles are '{{userRoles}}'",
        adminInformation:
            "The task requires the role '{{role}}' and is assigned to '{{assigned}}'. You have admin role and can change/perform the task.",
        completedActivity: 'The task is already completed.',
        rejectedActivity: 'The schema has been rejected.',
        SkipActivity:
            'This task is not relevant to the flow and will be skipped',
        processDefinition: {
            breadcrumb: 'Flowchart',
            back: 'Back to documentation',
            title: 'Visual representation of flowchart for process definition: {{processDefinitionId}}',
            iconTitle:
                'See more detailed representation of flowchart for process definitions',
            documentationTitle:
                'Documentation of flowchart for process definitions',
            selector: 'Select process definition',
            helperText: 'Select process definition to filter projects',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            resetZoom: 'Reset zoom',
            read: 'Open external link to Confluence page for process definition(s)',
        },
        definitions: {
            prosjekt_ltt_godkjenning: 'Tenant adaptation - Preliminary project',
            prosjekt_ltt_bestilling: 'Tenant adaptation - Implementation',
            prosjekt_ltt_endring: 'Tenant adaptation - Change',
            prosjekt_ltt_avslutning: 'Tenant adaptation - Completion',
            prosjekt_kom_skisse: 'KOM - Sketch',
            prosjekt_kom_opprettelse: 'KOM - Preliminary project',
            prosjekt_kom_bestilling: 'KOM - Implementation',
            prosjekt_kom_endring: 'KOM - Change',
            prosjekt_kom_avslutning: 'KOM - Completion',
            prosjekt_tek_igangsettelse: 'TEK - Preliminary project',
            prosjekt_tek_bestilling: 'TEK - Implementation',
            prosjekt_tek_endring: 'TEK - Change',
            prosjekt_tek_avslutning: 'TEK - Completion',
            tiltak_gjennomforing: 'Measure - Implementation',
            tiltak_avslutning: 'Measure - Completion',
        },
        fullmakt: {
            breadcrumb: 'Authorization limits',
            title: 'Authorization limits for project form',
            subtitle:
                'Overview of authorizations and approval authorities. All amounts are excl. VAT.',
            groupBy: 'Group by:',
            noGroup: 'Show all',
            table: {
                allTitle: 'All authorizations',
                region: 'Region',
                avdeling: 'Department',
                stilling: 'Position',
                innenfor: 'Budgeted',
                utover: 'Not budgeted',
                endring: 'Change in budget',
            },
        },
        statuses: {
            TilbudUnderGodkjenning: 'Offer under approval',
            Tilbud: 'Offer',
            UnderSkissering: 'Under sketching',
            Skissert: 'Sketched',
            LonnsomhetsberegningUnderGodkjenning:
                'Profitability assessment under approval',
            Lonnsomhetsberegning: 'Profitability assessment',
            ForprosjektUnderGodkjenning: 'Preliminary project under approval',
            Forprosjekt: 'Preliminary project',
            GjennomforingUnderGodkjenning: 'Implementation under approval',
            Gjennomforing: 'Implementation',
            TilEndring: 'Change budget under approval',
            Endret: 'Implementation changed budget',
            TilAvslutning: 'Completion under approval',
            Avsluttet: 'Completed',
            Avvist: 'Rejected',
        },
        table: {
            actionMenuItems: {
                stepHeader: 'Create schema for',
                currentHeader: "Actions for '{{stegNavn}}'",
                Igangsettelse: 'Initiation',
                Skisse: 'Sketch',
                Tilbud: 'Offer',
                Forprosjekt: 'Preliminary project',
                Godkjenning: 'Approval',
                Gjennomforing: 'Implementation',
                Endring: 'Budget change',
                Avslutning: 'Completion',
                detaljer: 'View details',
                tildel: 'Assign new responsible',
                tildelRolle: 'Assign new: {{rolle}}',
                sammendrag: 'View summary',
                sendReminder: 'Send reminder to responsible',
                sendReminderName: 'Send reminder to {{name}}',
                dokumentasjon: 'View documentation',
            },
            tildelAnsvarlig: {
                title: 'Assign new responsible',
                ansvarlig: 'Responsible',
                tildel: 'Assign',
                avbryt: 'Cancel',
                Prosjekteier: 'Project owner',
                Prosjektleder: 'Project manager',
                Forvaltningsdirektor: 'Director of administration',
                Utviklingsdirektor: 'Director of development',
                Administrerendedirektor: 'Managing director',
            },
            roller: {
                Prosjekteier: 'Project owner',
                Prosjektleder: 'Project manager',
                Forvaltningsdirektor: 'Director of administration',
                Utviklingsdirektor: 'Director of development',
                Administrerendedirektor: 'Managing director',
                Prosjektdirektor: 'Project director',
                Okonomisjef: 'Chief financial officer',
                Prosjektkontroller: 'Project controller',
                Okonomi: 'Accounting manager',
                Teknisksjef: 'Technical manager',
                Eiendomssjef: 'Property manager',
                Regiondirektor: 'Regional director',
                Ukjent: 'No roles',
            },
            subTypes: {
                Forprosjekt: 'Preliminary project',
                Gjennomforing: 'Implementation',
                Endring: 'Change',
                Avslutning: 'Completion',
                Tilbud: 'Offer',
            },
            registreringStatus: {
                Ny: 'New',
                Avvist: 'Rejected',
                Fullfort: 'Completed',
            },
            tableTitle: 'Completed tasks in the step',
            type: 'TYPE',
            navn: 'NAME',
            d365Prosjektnummer: 'NUMBER',
            eiendom: 'PROPERTY',
            rolle: 'ROLE(S)',
            email: 'EMAIL',
            signeringsDato: 'SIGNING DATE',
            beskrivelse: 'DESCRIPTION',
            status: 'STATUS',
            opprettetAv: 'CREATED BY',
            endretAv: 'CHANGED BY',
            ansvarlig: 'ASSIGNED TO',
            startDato: 'START DATE',
            sluttDato: 'END DATE',
            fullfortDato: 'COMPLETION DATE',
            action: 'ACTION',
            utforelseDato: 'EXECUTION DATE',
            oppgave: 'TASK',
            prosjekteier: 'PROJECT OWNER',
            prosjektleder: 'PROJECT MANAGER',
            emptyTableMessage:
                'We find no projects based on the filters you have selected.',
            lastNedDokument: 'Download document',
            forhaandsvisDokument: 'Preview document',
            visDetaljertProsjektregistrering:
                'View detailed overview of the selected process step',
            visProsjektSkjema: 'View form',
            visProsjektISuperoffice: 'Open project in SuperOffice',
            prosjektskjematype: 'PROJECT SCHEMA TYPE',
            aapneISuperOffice: 'Open project in SuperOffice',
        },
        filter: {
            prosjektskjematype: {
                label: 'Form type',
                all: 'All',
                hovedprosjekt: 'Main projects',
                underprosjekt: 'Subprojects',
            },
        },
        summary: {
            title: 'Project summary - {{prosjektNavn}}',
        },
        notification: 'Processing request. Please wait...',
        error: 'An error occurred. Please try again later.',
        deleteProject: {
            title: 'Delete schema',
            confirmationText: 'Are you sure you want to delete the schema?',
        },
        successfulRegistration: 'The project has been registered.',
        successfulOperation: 'The action was successfully performed.',
        notAssignedToUser:
            'You are not assigned this task and therefore cannot perform it.',
        notAllowedToPerformAction:
            'You do not have permission to perform this action.',
        newProcess: 'New projects',
        ongoingProcessForvalter: 'With administrator',
        ongoingProcessFinance: 'With finance',
        startRegistration: 'Start registration',
        declined: 'Rejected',
        approved: 'Approved',
        forApproval: 'For approval',
        assignedToMe: 'Assigned to me',
        avvistKommentarTitle:
            "The task '{{avvistOppgave}}' has been rejected with the following comment:",
        stepper: {
            unathorisedStep: 'You do not have access to this step',
        },
        vurderingsskjema: {
            close: 'Close',
            open: 'Open evaluation form',
            title: 'Evaluation form',
            sum: 'Sum: ',
            oppsummeringAvSummer: 'Summary of sums',
            sumAlleKategorier: 'All categories: ',
            sumAktivering: 'Activation: ',
            sumKostnadsforing: 'Cost posting: ',
            sumAndelAktivering: 'Share of activation: ',
            sumAndelKostnadsforing: 'Share of cost posting: ',
            navn: 'Name',
            kostkategoriId: 'Cost category ID',
            kostnadsforing: 'Cost posting',
            aktivering: 'Activation',
            total: 'Total',
            totalOversikt: 'Total based on form',
            kommentar: 'Comment',
            inputMode: {
                toggleLabel: 'Enter total and percentage split',
                helperText:
                    'Type a total and percentage per row; activation and expense amounts are computed automatically.',
                aktiveringPct: 'Activation %',
                kostnadsforingPct: 'Expense %',
            },
            error: {
                paakrevdKommentar: 'Comment required',
                hasErrors: 'Form has {{count}} errors',
                hasErrors_1: 'Form has 1 error',
            },
        },
        kostnadskalkyle: {
            title: {
                tab: 'Estimate',
                general: 'Estimate and profitability calculation for project',
                kalkyle: 'Estimate for project: {{prosjektNavn}}',
                lonsomhetsberegning:
                    'Profitability calculation for project: {{prosjektNavn}}',
                modalButton: 'Open estimate',
            },

            submit: 'Submit estimate',
            administrerKostnadstyper: 'Manage cost types',
            disabledTab: 'Disabled for this project type',
            leggTilKostnadstype: 'Add cost type',
            addKostnadstype: {
                name: 'Name',
                duplicateError: "Cost type '{{name}}' already exists",
            },
            velgKostnadstype: 'Select cost type',
            kostnadstypeWarning: 'Selected cost type is marked as deleted',
            velgKostkategori: 'Select cost category',
            lagrer: 'Saving',
            lagre: 'Add',
            prosjektArealM2: 'Project area (m²)',
            risikotilleggSats: 'Risk surcharge rate (%)',
            prosjektlederSats: 'Project manager hours rate (%)',
            tillegg: {
                title: 'Additions',
                risiko: 'Risk',
                prosjektleder: 'Project manager',
                time: 'hour',
                timer: 'hours',
            },
            leieobjektArealM2: 'Leased object area (m²)',
            kontraktsleiePerM2: 'Contract rent per m²',
            leieperiode: 'Rent period (years)',
            aarligLeie: 'Annual rent',
            totalLeie: 'Total rent',
            error: {
                kostnadstypeRequired: 'Cost type is required',
                satsRequired: 'Rate is required',
                satsRange: 'Rate must be between 0 and 100',
                enhetRequired: 'Unit is required',
                enhetPositive: 'Unit must be greater than 0',
                prisPerEnhetRequired: 'Price per unit is required',
                prisPerEnhetPositive: 'Price per unit must be greater than 0',
                andelKostnadsforingRequired:
                    'Proportion of cost allocation is required',
            },
            table: {
                kostnadstype: 'Cost type',
                beskrivelse: 'Description',
                kostnad: 'Cost',
                enhet: 'Quantity (pcs/m/m²)',
                prisPrEnhet: 'Price per unit',
                aktiveringsandel: 'Activation share (%)',
                kostnadsforingAndel: 'Cost Allocation (%)',
                sumAktivering: 'Total activation',
                handlinger: 'Actions',
                addRow: 'Add row',
            },
            summary: {
                section_project: 'Key figures about the project',
                totalKostnad: 'Total cost',
                kvadratMeterPris: 'Price per square meter',

                section_historical: 'Historical key figures for the property',
                gjennomsnittligKostnadPerM2: 'Average cost per m²',

                section_financial: 'Key figures for accounting',
                andelAktiveres: 'Share activated',
                andelKostnadsfores: 'Share expensed',
            },
        },
        lonnsomhet: {
            title: 'Profitability',
            fields: {
                kontraktleieTotaltPerAar: 'Total contract rent/yr',
                grunnleiePerM2: 'Base rent per m²',
                oktLeiePerM2PerAar: 'Increased rent per m²/yr',
                nyGrunnleiePerM2PerAar: 'New base rent per m²/yr',
                inflasjon: 'Inflation (%)',
                avkastningskrav: 'Return requirement (%)',
                realAvkastningskrav: 'Real return requirement (%)',
                oktInntektPerM2PerAar: 'Increased income per m²/yr',
                oktInntektPerAar: 'Increased income/yr',
                terminerPerAar: 'Installments per year',
                kontraktstid: 'Contract period (yrs)',
            },
            table: {
                navn: 'Name',
                investeringskostnad: 'Investment cost',
                avskrivningstid: 'Depreciation period',
                restverdi: 'Residual value (%)',
                aarligOktLeiepris: 'Annual increased rent',
                oktLeieprisPerM2: 'Increased rent per m²',
                leggTilDelprosjekt: 'Add subproject',
                totalt: 'Total',
                nettoLeie: 'Net rent',
                inkluderMvaKompensasjon: 'Include VAT',
                noData: 'There is no data in the cost calculator yet. Please fill out the form to see the profitability calculation.',
            },
        },
        kostnadstyper: {
            title: 'Cost Types',
            showDeleted: 'Show deleted cost types',
            table: {
                navn: 'Name',
                kostkategori: 'Cost Category',
                defaultCost: 'Default Cost',
                defaultKostnadsforingAndel: 'Default Cost Allocation Share (%)',
                edit: 'Edit cost type',
                save: 'Save cost type',
                add: 'Add cost type',
                delete: 'Delete cost type',
                deletePrompt: 'Are you sure you want to delete this cost type?',
                deleteConfirm: 'Delete',
                cancel: 'Cancel',
                restore: 'Restore cost type',
                duplicateError:
                    'A cost type with the same name and cost category already exists',
            },
            error: {
                navnRequired: 'Name is required',
                kostKategoriRequired: 'Cost category is required',
                duplicate:
                    'The cost type with name {{name}} and cost category {{kostkategori}} already exists',
            },
        },
        leverandor: {
            organizationSelect: 'Requested business',
            organizationPlaceholder: 'Organization number/name',
            price: 'Price',
            priceRevised: 'Revised price',
            selected: 'Selected',
            klassifisering: 'Classification',
            add: 'Add',
        },
        vedlegg: {
            add: 'Add attachment',
            delete: 'Delete attachment',
            loading: 'Uploading attachment',
        },
        budsjettnummer: {
            title: "Budget '{{number}}' in D365",
            period: 'Period: {{from}} - {{to}}',
            budget: 'ExVAT: {{exMva}}, VAT: {{mva}}, Total: {{total}}',
        },
        dokument: {
            add: 'Add',
            loading: 'Uploading',
        },
        TildelKommentarer: {
            field: {
                label: 'Comment when assigning',
                placeholder: 'Write a comment to the person you are assigning',
                error: {
                    commentTooLong: {
                        en: 'Could not save the comment in the form. The comment is too long and exceeds the allowed length.',
                    },
                },
            },
            list: {
                title: 'Comments when assigning',
                empty: 'No comments',
            },
        },
    },
    frontPage: {
        buildings: 'Property',
        buildingsLink: 'My properties',
        contract: 'Contracts',
        expiring: 'Expiring contracts',
        frontpage: 'Frontpage',
        invoice: 'Invoices',
        invoiceLink: 'All invoices',
        messages: 'Message board',
        messagesLink: 'All messages',
        mytasksLink: 'Task overview',
        welcome: {
            forvalter: 'Welcome to the Real estate dashboard',
            mittleieforhold: 'Welcome to My Lease',
            yourAdminDashboard:
                'Welcome to the Real estate Dashboard, {{name}}',
        },
        adjustFrontpage: {
            title: 'Adjust the front page',
            alert: 'The default front page for your role is now displayed. You can easily customize the front page to your needs below.',
            select: 'Select what is displayed on the front page',
            frontpageCardsSelector: {
                utestaaendeFordringer: 'Overdue payments',
                arealmessigUtleiegrad: 'Area-wise occupancy rate',
                kontrakter: 'Contracts',
                prosjekter: 'Projects/initiatives',
                saker: 'Tickets',
                leverandor: 'Supplier',
            },
        },
        survey: {
            title: 'Hello{{name}}!',
            description1:
                'Do you have 5 minutes to give some feedback about how we can improve the Real Estate Dashboard?',
            description2: 'Vi i IT-avdelingen setter stor pris på hjelpen din!',
            linkText: 'Gå til spørreundersøkelsen',
        },
        expiredContracts: {
            actionButtonText: 'Available areas',
            area: 'Area',
            areaRatio: 'Area-wise occupancy rate',
            available: 'Available',
            contracts: 'Contracts',
            econRatio: 'Economical occupancy rate',
            income: 'Rental income',
            marketValue: 'Market Value',
            nokperyear: 'NOK/Year',
            rented: 'Rented',
            rentedExpiring: 'Expiring',
            title: 'Available Areas',
            yourAvailableAreasDate: 'Your available areas as of ',
            yourRentedAreasDate: 'Your leased areas as of ',
        },
        expiringContracts: {
            actionButtonText: 'Details',
            title: 'Expiring contracts',
            yourExpiringContracts: 'Your expiring contracts',
            yourRentalRateDate: 'Your rental rate as of ',
        },
        utestaaendeFordringer: {
            actionButtonText: 'See the report',
            allReceivables: 'See all overdue payments',
            emptyResult: 'There is no late payments at the moment.',
            subtitle: 'Clients with overdue payments',
            title: 'Overdue payments',
        },
        contractManagement: {
            actionButtonText: 'Contract Management',
            contractsToRegistration: 'Pending registration in D365',
            negotiations: 'Negotiations',
            signableContracts: 'Contract for signing',
            subtitle: 'Contract management',
            title: 'Contracts',
            newProsessLink: 'Start new process',
            infoText:
                'This contract overview is not filtered on the selected building.',
        },
        project: {
            actionButtonText: 'Project form',
            subtitle: 'Project management',
            title: 'Projects',
            newProjectLink: 'Create New Project',
            infoText:
                'This project overview is not filtered on the selected building.',
        },
        sak: {
            actionButtonText: 'Tickets overview',
            subtitle: 'Tickets follow-up',
            title: 'Tickets',
            noTickets: 'No tickets',
            sakStatus: {
                Aktiv: 'Active',
                Avsluttet: 'Closed',
                Sammenslått: 'Merged',
                Slettet: 'Deleted',
                Unknown: 'Unknown',
                Utsatt: 'Postponed',
                'Venter på 3dje part': 'Waiting for third party',
                'Venter på kunde': 'Waiting for customer',
                Påbörjad: 'Started',
                'Ej påbörjad': 'Not started',
            },
        },
        leverandor: {
            title: 'Supplier',
            subtitle: 'Supplier',
            assignedToMe: 'Assigned to me',
            underAssessment: 'Under assessment',
            completed: 'Completed',
            rejected: 'Rejected',
            actionButtonText: 'Supplier form',
        },
    },
    general: {
        backToTop: 'Back to top',
        by: 'by',
        cancel: 'Cancel',
        charactersRemaining: '{{count}} characters remaining',
        clear: 'Clear',
        clearList: 'Clear list',
        clearSelection: 'Clear selection',
        close: 'Close',
        confirm: 'Yes',
        contextSelectorSearchField: 'Search for building department',
        contextSelectorHint: "Add building department to 'My buildings'",
        days_0: 'day',
        days: 'days',
        decline: 'No',
        delete: 'Delete',
        deleteYes: 'Yes, delete',
        details: 'Details',
        download: 'Download',
        draft: 'Draft',
        edit: 'Edit',
        emptyList: 'List is empty',
        error: {
            title: 'Error',
            message: 'An error occurred.\nPlease try again later.',
            messageWithDetails:
                'An error occurred:\n{{errorMessage}}.\nPlease try again later.',
            apiErrorTitle: 'Error messages:',
            apiErrorTitle_1: 'Error message:',
            apiError:
                'An error occurred while fetching data. The development team has been notified. We apologize for the inconvenience.',
            reloadPage: 'Reload the page',
        },

        expired: 'Expired',
        expiryTime: {
            expired: '(Expired):',
            expires_within_6m: '(6 mths)',
            expires_within_1y: '(1 yr)',
            expires_within_2y: '(2 yrs)',
            expires_within_3y: '(3 yrs)',
            expires_within_4y: '(4 yrs)',
        },
        links: 'Links',
        goBack: 'Go back',
        goBackToFrontpage: 'Go back to the frontpage',
        loading: 'Loading...',
        menu: 'Menu',
        month: 'Month',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'May',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Oct',
        month_10: 'Nov',
        month_11: 'Des',
        // tslint:disable-next-line: max-line-length
        noIe: 'We are sorry, but this feature is not supported in Internet Explorer. We recommend to use Google Chrome or Mozilla Firefox browser.',
        name: 'Name',
        of: 'of',
        open: 'Open',
        pageNotFound: 'Page not found',
        preview: 'Preview',
        previewDownload: 'PREVIEW / DOWNLOAD',
        publish: 'Publish',
        readMore: 'Read more',
        reload: 'Reload',
        reset: 'Reset',
        revert: 'Revert',
        save: 'Save',
        saveAsDraft: 'Save as draft',
        saved: 'Saved',
        saving: 'Saving...',
        savingError: 'Error during saving',
        show: 'show',
        showAll: 'Show all',
        submit: 'Submit',
        sum: 'sum',
        updating: 'Updating...',
        unknown: 'Unknown',
        wrote: 'Wrote',
    },
    languageName: 'English',
    report: {
        error: 'Error while loading reports.',
        name: {
            ArealOgKontrakt: 'Area and Contracts',
            Kundereskontro: 'Customer Ledger',
            Prosjekt: 'Project',
            Regnskap: 'Accounting',
        },
        open: 'Open',
        report: 'Report',
        title: 'Reports',
    },
    tables: {
        antallTreff_one: '{{count}} result',
        antallTreff: '{{count}} results',
        body: {
            noMatch: 'Sorry, no matching records found',
            toolTip: 'Sort',
            toolTipFor: `Sort for `,
        },
        pagination: {
            displayRows: 'of',
            next: 'Next Page',
            previous: 'Previous Page',
            rowsPerPage: 'Rows per page:',
        },
        toolbar: {
            downloadCsv: 'Download CSV',
            filterTable: 'Filter Table',
            print: 'Print',
            search: 'Search',
            viewColumns: 'View Columns',
        },
        filter: {
            all: 'All',
            reset: 'RESET',
            title: 'FILTERS',
        },
        viewColumns: {
            title: 'Show Columns',
            titleAria: 'Show/Hide Table Columns',
        },
        selectedRows: {
            delete: 'Delete',
            deleteAria: 'Delete Selected Rows',
            text: 'row(s) selected',
        },
        labelRowsPerPage: 'Rows per page:',
    },
    validator: {
        email: 'Valid email is required',
        required: 'The field is required',
    },
    sustainability: {
        prosjektAvfall: {
            title: 'Sustainability in projects',
            description:
                'This report shows sustainability metrics for completed projects within a given period. Data for individual projects are listed in the table.',
            fromDate: 'Completed, from date',
            toDate: 'Completed, to date',
            reset: 'Reset to last quarter',
            uploadRapport: 'Upload waste report manually',
            projectLabel: 'Select project',
            projectWarning:
                'Project already has a waste report, it will be overwritten by new waste report.',
            selectFile: 'Select file',
            uploadRapportSuccess:
                'The waste report has been uploaded and is being analyzed.',
            sluttrapportLabel: 'Waste report',
            lastOppRapport: 'Upload waste report',
            uploadKlimagass: 'Enter greenhouse gas emissions manually',
            lagreKlimagass: 'Save greenhouse gas emissions',
            updateKlimagassSuccess: 'Greenhouse gas emissions updated',
            summary: 'Summary',
            antallProsjekter: 'Number of projects',
            antallProsjekterMedRapport: 'Number of projects with waste report',
            totalAvfall: 'Total waste',
            sorteringsgrad: 'Sorting degree',
            tableTitle: 'Projects',
            prosjektnummer: 'Number',
            prosjekttype: 'Type',
            prosjektnavn: 'Name',
            region: 'Region',
            byggtype: 'Property type',
            bygg: 'Property',
            prosjektleder: 'Project manager',
            klimagassberegning: 'Calculated emissions',
            klimagassRelevant: 'Emissions calculation relevant',
            klimagassRelevantHint:
                "Project manager's answer at project start: is a greenhouse gas calculation (Reduzer or similar, A1–A5 per NS 3720:2018) relevant for the project?",
            klimagassForklaring: 'Reason (if no)',
            relevantJa: 'Yes',
            relevantNei: 'No',
            lesMer: 'Read more',
            prosjektSum: 'Total waste volume',
            document: 'Waste report',
            documentTooltip: 'Show waste report',
            emptyTable: 'No completed projects found',
            sortert: 'Total sorted',
            usortert: 'Total unsorted',
            sum: 'Sum',
            sorteringHeader: 'Sorting',
            avfallTypeHeader: 'Product group',
            beskrivelseHeader: 'Description',
            transporterHeader: 'Number of transports',
            volumHeader: 'Waste volume',
            volumAndelHeader: 'Share',
            analyzeAction: 'Reanalyze report',
            analyzeWarning:
                'Previous waste for the project will be overwritten',
            editAction: 'Manual edit',
            addRow: 'Add row',
            updateSuccess: 'Waste updated',
            error: {
                validation: 'Please correct the errors before saving',
                invalidMengde: 'Amount must be greater than or equal 0',
                invalidKlimagassberegning:
                    'Greenhouse gas calculation must be greater than or equal 0',
                typeRequired: 'Waste type is required',
            },
        },
    },
    reportMapping: {
        menu: {
            title: 'Energinet Report Mapping',
        },
        breadcrumbs: {
            reportMapping: 'Energinet Report Mapping',
            documentation: 'Documentation',
        },
        documentation: {
            title: 'Documentation',
            openExternal: 'Open external link to Confluence page',
            backButton: 'Back to report mapping',
            viewInConfluence: 'Open documentation in Confluence',
        },
        mappingAdd: {
            title: 'New Mapping',
            titleMappingFor: 'New mapping for report:',
            selectReport: 'Select Report',
            selectBuilding: 'Select Building',
            selectCustomer: 'Select Customer',
            selectReportType: 'Select Report Type',
            searchBuildings: 'Search buildings...',
            searchCustomers: 'Search customers...',
            searchReports: 'Search reports...',
            save: 'Save',
        },
        mappingEdit: {
            title: 'Edit Mapping',
            titleMappingFor: 'Edit mapping for report:',
            save: 'Update',
        },
        mappingTransfer: {
            title: 'Transfer report',
            titleMappingFor: 'Transfer report:',
            transfer: 'Transfer',
            success:
                'The report was successfully transferred and synchronized with other systems.',
            disclaimer:
                'NB! When saving the report, it will be synchronized with other systems. This can take up to 3 minutes. Please do not close the window until the synchronization is complete.',
            disclaimerNightly:
                'If you do not want to transfer now, reports will be transferred during nightly synchronization',
        },
        mappingTable: {
            type: 'Type',
            report: 'Report',
            building: 'Building',
            customer: 'Customer',
            actions: 'Actions',
            filterByStatus: 'Filter by status',
            all: 'All',
            mapped: 'Mapped',
            unmapped: 'Unmapped',
        },
        mappingDelete: {
            title: 'Delete Mapping',
            confirmationText: 'Are you sure you want to delete this mapping?',
        },
        mappingsSummary: {
            totalMappings: 'Reports',
            withBygg: 'Connected to building',
            withKunde: 'Connected to building and customer',
        },
        error: {
            noAvailableReports:
                'No available reports to map for the selected building.',
            saveFailed: 'Could not save the report. Please try again.',
            transferFailed:
                'The report was saved, but synchronization with other systems failed. Synchronization will be retried automatically.',
        },
        reportType: {
            Unknown: 'Unknown',
            Energy: 'Time series report on energy carriers',
            Waste: 'Waste report on fractions or fraction groups',
            MonthlyEnergy: 'Monthly report on energy carriers',
            Water: 'Water report on consumption last 24 months',
            AdjustedEnergy:
                'Degree day corrected energy report, for this year relative to last 4 years',
            MonthlyCustomerEnergy:
                'Monthly report on energy carriers (only for customer portal)',
            CustomerSpecificEnergy: 'Energy report specific to customer',
        },
    },
    devRoleSelector: {
        label: 'Selected test role',
        heading: 'Select test role',
        original: 'Original (real role)',
        forvalterKontor: 'Forvalter – Office (Asbjørn)',
        forvalterKjopesenter: 'Forvalter – Shopping Centre (Carl Christian)',
        okonomi: 'Finance (Valarmathy)',
        okonomiQA: 'Finance QA (Solrunn)',
        prosjektleder: 'Project Manager/Owner (Henriette)',
    },
};
